import { useSurfacePreferences } from "@/components/preferences/usePreferences.tsx";
import { CalendarSelection } from "@/views/Settings/Calendars.tsx";

/**
 * The busy-calendar chooser, inline in a card.
 *
 * Renders the same `CalendarSelection` the Connected Calendars settings screen
 * does, rather than a second list that would drift from it. That component
 * already fits a picker card without changes: it reads the calendar list itself,
 * autosaves on every toggle instead of behind a Save button, and keeps primary
 * calendars selected and non-toggleable.
 *
 * Selection comes from live preferences, not from the artifact — so a calendar
 * marked busy anywhere else is already reflected when this card is reopened.
 */
export const CalendarsPickerBody = () => {
  const { selectedCalendarIds } = useSurfacePreferences("calendars");
  return <CalendarSelection selectedCalendarIds={selectedCalendarIds} />;
};
